<span class="notification-indicator">
  <span class="unseen-red-icon" *ngIf="!!getUnseenNotificationsCount()"></span>

  <button mat-icon-button *ngIf="user?.id" [matMenuTriggerFor]="belowMenu">
    <img
      src="../../../../../assets/preneed/bell.svg"
      alt=""
      class="bell-icon"
    />
  </button>

  <mat-menu #belowMenu="matMenu" xPosition="before">
    <app-notification-area
      [notifications]="notifications"
      #notificationArea
    ></app-notification-area>
  </mat-menu>
</span>
